import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import "../../assets/css/AccountVerification.css";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import config from "../../config";
import {
    clientLogo1,
    clientLogo2,
    clientLogo3,
    clientLogo4,
    clientLogo5,
    clientLogo6,
} from "../../Constant";
import { VerifyResetCode } from "../../redux/actions/auth";

const AccountVerification = ({ VerifyCode }) => {
    const [code, setCode] = useState("");

    const { email } = useParams();

    const navigate = useNavigate();

    const submit = async (e) => {
        e.preventDefault();
        try {
            await VerifyCode(code, () =>
                navigate(`/reset-password/${email}/${code}`)
            );
        } catch (e) {
            console.log(e);
        }
    };
    return (
        <>
            <Header />
            {/* <!-- Introduce Yourself Sec Start Here --> */}
            <section className="acc-verification">
                <div className="container">
                    <div className="row">
                        <div className="col-md-3"></div>
                        <div className="col-md-6">
                            <div className="verification_box">
                                <div className="heading_wrapper">
                                    <h4>Account Verification</h4>
                                    <p>
                                        An email with verification code is sent
                                        to
                                        <br />
                                        <span className="email">
                                            {config.hideEmail(email)}
                                        </span>
                                    </p>
                                </div>
                                <form
                                    id="resetForm"
                                    className="form"
                                    action=""
                                    method="post"
                                    onSubmit={submit}
                                >
                                    <label htmlFor="code">Enter Code </label>
                                    <input
                                        required
                                        type="text"
                                        placeholder="Enter your code"
                                        className="form-control"
                                        id="resetCode"
                                        maxLength={4}
                                        value={code}
                                        onChange={(e) => {
                                            if (e.target.value != "") {
                                                if (
                                                    /^[0-9]+$/.test(
                                                        e.target.value
                                                    )
                                                ) {
                                                    setCode(e.target.value);
                                                }
                                            } else {
                                                setCode("");
                                            }
                                        }}
                                    />
                                    <input
                                        id=""
                                        type="submit"
                                        name="submit"
                                        className="buttons"
                                        value="Next"
                                    />
                                    {/* <!--                            <button className="buttons" type="submit">Next</button>--> */}
                                </form>
                                <div className="signupDv">
                                    <p>
                                        Not a Member ?{" "}
                                        <Link to={`/signup`}>Sign up</Link>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3"></div>
                    </div>
                </div>
            </section>
            {/* <!-- Introduce Yourself Sec End Here --> */}

            {/* <!-- Brands Div Start Here --> */}
            <section className="brandsDv">
                <div className="container">
                    <hr />
                    <div className="row">
                        <div className="col-lg-2 col-md-4">
                            <div className="brand_img">
                                <figure>
                                    <img src={clientLogo1} alt="" />
                                </figure>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-4">
                            <div className="brand_img">
                                <figure>
                                    <img src={clientLogo2} alt="" />
                                </figure>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-4">
                            <div className="brand_img">
                                <figure>
                                    <img src={clientLogo3} alt="" />
                                </figure>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-4">
                            <div className="brand_img">
                                <figure>
                                    <img src={clientLogo4} alt="" />
                                </figure>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-4">
                            <div className="brand_img">
                                <figure>
                                    <img src={clientLogo5} alt="" />
                                </figure>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-4">
                            <div className="brand_img">
                                <figure>
                                    <img src={clientLogo6} alt="" />
                                </figure>
                            </div>
                        </div>
                    </div>
                    <hr />
                </div>
            </section>
            {/* <!-- Brands Div End Here --></div> */}
            <Footer />
        </>
    );
};

const mapDispatchToProps = (dispatch) => ({
    VerifyCode: async (code, cb) => dispatch(await VerifyResetCode(code, cb)),
});

export default connect(null, mapDispatchToProps)(AccountVerification);
